import PriceTable from './PriceTable';

export default PriceTable;
